import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center gap-x-2" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "w-1 h-2.5 rounded-full",
  style: {"background-color":"#56BEF2"}
}, null, -1)
const _hoisted_3 = { class: "font-medium text-black-lp-100 text-sm" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-y-2 items-center py-4"
}
const _hoisted_5 = { class: "text-black-lp-300 font-semibold text-sm" }
const _hoisted_6 = { class: "text-xs text-gray-lp-800 text-center w-full sm:w-60" }
const _hoisted_7 = { class: "flex items-center justify-center gap-x-2" }
const _hoisted_8 = {
  class: "font-bold text-sm text-black-lp-100 leading-9",
  style: {"font-size":"34px"}
}
const _hoisted_9 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-2 gap-3"
}
const _hoisted_10 = { class: "font-semibold text-xl text-black-lp-100" }
const _hoisted_11 = { class: "font-semibold text-xl text-black-lp-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_TooltipV2 = _resolveComponent("TooltipV2")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    class: "px-3 sm:px-5 py-3 flex flex-col gap-y-3",
    rounded: "xl",
    color: "gray-lp-2800",
    isShadow: false,
    customClass: "border border-gray-lp-1500"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("dashboard.cardTotalProfit.title")), 1)
      ]),
      (_ctx.data.errorOverview)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("dashboard.cardTotalProfit.systemError")), 1),
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("dashboard.cardTotalProfit.reloadInstruction")), 1),
            _createVNode("button", {
              class: "flex items-center gap-x-2 text-red-lp-100 text-xs font-semibold focus:outline-none",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRefresh && _ctx.onRefresh(...args)))
            }, [
              _createVNode(_component_Icons, {
                name: "reload",
                class: "w-4"
              }),
              _createVNode("span", null, _toDisplayString(_ctx.$t("dashboard.cardTotalProfit.reload")), 1)
            ])
          ]))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("div", _hoisted_7, [
              (_ctx.data.isLoadingOverview)
                ? (_openBlock(), _createBlock(_component_Skeleton, {
                    key: 0,
                    height: "2.5rem",
                    width: "33%"
                  }))
                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode("span", _hoisted_8, _toDisplayString(_ctx.formatPriceRP(_ctx.data.overviewData.overview.totalProfit, _ctx.accountCurrency)), 1),
                    (_ctx.data.overviewData.totalProfitDifferencePercentage !== 0)
                      ? (_openBlock(), _createBlock("span", {
                          key: 0,
                          class: ["font-medium text-base flex items-center gap-x-1", [
              {
                'text-red-lp-100':
                  _ctx.data.overviewData.totalProfitDifferencePercentage < 0
              },
              {
                'text-green-lp-100 ':
                  _ctx.data.overviewData.totalProfitDifferencePercentage > 0
              }
            ]]
                        }, [
                          _createVNode(_component_Icons, {
                            name: "arrow-up",
                            class: ["w-2", [
                {
                  'transform rotate-180':
                    _ctx.data.overviewData.totalProfitDifferencePercentage < 0
                }
              ]]
                          }, null, 8, ["class"]),
                          _createTextVNode(" " + _toDisplayString(Math.abs(_ctx.data.overviewData.totalProfitDifferencePercentage)) + "% ", 1)
                        ], 2))
                      : _createCommentVNode("", true)
                  ], 64))
            ]),
            (_ctx.data.isLoadingOverview)
              ? (_openBlock(), _createBlock(_component_Skeleton, {
                  key: 0,
                  height: "5rem",
                  width: "100%"
                }))
              : (_openBlock(), _createBlock("div", _hoisted_9, [
                  _createVNode(_component_Card, {
                    class: "p-2 flex flex-col items-center justify-center gap-y-1 border",
                    style: {"border-color":"#58BFF3"},
                    rounded: "xl",
                    isShadow: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_TooltipV2, {
                        text: _ctx.$t('dashboard.cardTotalProfit.earnedProfitTitle'),
                        description: _ctx.$t('dashboard.cardTotalProfit.earnedProfitDescription'),
                        iconFill: false
                      }, null, 8, ["text", "description"]),
                      _createVNode("span", _hoisted_10, _toDisplayString(_ctx.formatPriceRP(_ctx.data.overviewData.overview.earnedProfit, _ctx.accountCurrency)), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Card, {
                    class: "p-2 flex flex-col items-center justify-center gap-y-1 border",
                    style: {"border-color":"#ED6240"},
                    rounded: "xl",
                    isShadow: false
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_TooltipV2, {
                        text: _ctx.$t('dashboard.cardTotalProfit.pendingProfitTitle'),
                        description: _ctx.$t('dashboard.cardTotalProfit.pendingProfitDescription'),
                        iconFill: false
                      }, null, 8, ["text", "description"]),
                      _createVNode("span", _hoisted_11, _toDisplayString(_ctx.formatPriceRP(_ctx.data.overviewData.overview.pendingProfit, _ctx.accountCurrency)), 1)
                    ]),
                    _: 1
                  })
                ]))
          ], 64))
    ]),
    _: 1
  }))
}